import {
  CasesValue,
  TAiTipRequest,
  TCaseObjectKeys,
} from "../../../services/api/instances/casesApi/types";
import { EMPTY_AI_TIP_DATA } from "../constants";

export const aggregateDataForAiTip = (
  value: CasesValue | null,
  field: TCaseObjectKeys,
): TAiTipRequest => {
  if (!value) return EMPTY_AI_TIP_DATA;
  const {
    case_info,
    case_artifacts_chain,
    case_transform_method,
    case_metadata,
  } = value.case_object;
  return {
    task_description: case_info?.task_description ?? "",
    input_artifact: case_artifacts_chain?.input_artifact ?? "",
    output_artifact: case_artifacts_chain?.output_artifact ?? "",
    consumer: case_artifacts_chain?.consumer ?? "",
    knowledge: case_transform_method?.knowledge ?? "",
    output_attributes: case_transform_method?.output_attributes ?? "",
    field: field,
    current: "",
  };
};
